//import $ from 'jquery';
import { Splide, SplideSlide } from '@splidejs/splide/dist/js/splide.esm.js'
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.umd.js";
import Headroom from "headroom.js";
import 'a11y-accordion-tabs';

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting === true) {
				entry.target.classList.add("fade-in--is-visible");
			} else {
				//entry.target.classList.remove("fade-in--is-visible");
			}
		});
	});
	var items = document.querySelectorAll(".fade-in");
	items.forEach(function (item, index) {
		observer.observe(item, index);
	});
} else {
	document.querySelector("body").classList.add("no-intersection-observer")
}

/* ==========================================================================
   Headroom - change header on scroll
   ========================================================================== */

var headroomOptions = {
	offset: {
		up: 0,
		down: 110
	}
}
const headroomHeader = document.querySelector(".header");
const headroom = new Headroom(headroomHeader, headroomOptions);
headroom.init();

//Show the header when hovering at the top of the page
headroomHeader.addEventListener(
	"mouseenter",
	(event) => {
		event.target.classList.remove("headroom--unpinned");
		event.target.classList.add("headroom--pinned");
	},
	false,
);

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

const navButton = document.querySelector(".js-trigger-mobile-nav");
const navElement = document.querySelector(".main-nav");

navButton.addEventListener("click", function () {
	navElement.classList.toggle("is-active");
	this.classList.toggle("is-active");
});

/* ==========================================================================
   Mobile Sub Nav Toggle
   ========================================================================== */

var subNavButtonEls = document.querySelectorAll(".js-toggle-subnav");

for (let i = 0; i < subNavButtonEls.length; i++) {
    subNavButtonEls[i].addEventListener("click", function (e) {
        if (window.innerWidth > 1024) {
            return;
        }

        e.preventDefault();
        this.classList.toggle("subnav-active");
    });
}

/* ==========================================================================
   Search Popup Toggle
   ========================================================================== */

function toggleSearchModal() {
	document.getElementById("search-modal").classList.toggle("is-active");
}

/* ==========================================================================
   Share Popup Toggle
   ========================================================================== */

function toggleSharePopup() {
	document.querySelector(".share-component__popup").classList.toggle("is-active");
}

/* ==========================================================================
   Find Architect Popup Toggle
   ========================================================================== */

function toggleArchitectLocationPopup() {
	document.querySelector("#architect-location-popup .block-find-architect__menu-popup").classList.toggle("is-active");
	document.querySelector("#architect-location-popup .block-find-architect__menu-button").classList.toggle("is-active");
	document.querySelector("#architect-project-type-popup .block-find-architect__menu-popup").classList.remove("is-active");
	document.querySelector("#architect-project-type-popup .block-find-architect__menu-button").classList.remove("is-active");
}


function toggleArchitectProjectTypePopup() {
	document.querySelector("#architect-project-type-popup .block-find-architect__menu-popup").classList.toggle("is-active");
	document.querySelector("#architect-project-type-popup .block-find-architect__menu-button").classList.toggle("is-active");
	document.querySelector("#architect-location-popup .block-find-architect__menu-popup").classList.remove("is-active");
	document.querySelector("#architect-location-popup .block-find-architect__menu-button").classList.remove("is-active");
}

/* ==========================================================================
   Splide Slider/Carousel
   ========================================================================== */

function SlideCounterExtension(Splide, Components) {
	const { track } = Components.Elements;

	let elm;
	let splideIndex;
	let splideIndexPad, splideLengthPad;
	let splideLength

	function mount() {
		elm = document.createElement('div');
		elm.classList.add('splide__counter');

		track.parentElement.insertBefore(elm, track.nextSibling);

		update();
		Splide.on('move', update);
	}

	function update() {
		// Add leading zero to the numbers
		splideIndex = Splide.index + 1;
		splideIndexPad = splideIndex.toString().padStart(2, '0')
		splideLength = Splide.length;
		splideLengthPad = splideLength.toString().padStart(2, '0')
		elm.textContent = `${splideIndexPad} — ${splideLengthPad}`;
	}

	return {
		mount,
	};
}

if (document.getElementsByClassName("js-featured-slider").length) {
	new Splide('.js-featured-slider', {
		type: 'loop',
		perPage: 1,
		arrows: false,
		pagination: false,
		gap: '20px',
		lazyLoad: 'nearby',
		arrowPath: 'M5,21h27.6l-4.7,4.7c-.4.4-.4,1,0,1.4s1,.4,1.4,0l6.4-6.4c.4-.4.4-1,0-1.4l-6.4-6.4c-.4-.4-1-.4-1.4,0s-.4,1,0,1.4l4.7,4.7H4v2h1Z',
		breakpoints: {
			768: {
				arrows: true
			},
		},
	}).mount({
		SlideCounterExtension
	});
}

if (document.getElementsByClassName("js-awards-slider").length) {
	new Splide('.js-awards-slider', {
		type: 'loop',
		perPage: 2,
		arrows: true,
		pagination: false,
		gap: '20px',
		lazyLoad: 'nearby',
		arrowPath: 'M5,21h27.6l-4.7,4.7c-.4.4-.4,1,0,1.4s1,.4,1.4,0l6.4-6.4c.4-.4.4-1,0-1.4l-6.4-6.4c-.4-.4-1-.4-1.4,0s-.4,1,0,1.4l4.7,4.7H4v2h1Z',
		breakpoints: {
			768: {
				perPage: 1
			},
		},
	}).mount({
		SlideCounterExtension
	});
}

const awardsfilmsslider = document.querySelectorAll(".js-awards-films-slider");
awardsfilmsslider.forEach(filmslider => {
	new Splide(filmslider, {
		type: 'loop',
		perPage: 1,
		arrows: true,
		pagination: false,
		gap: '20px',
		lazyLoad: 'nearby',
		arrowPath: 'M39.8,19.6l-4.2-4.2c-.3-.3-.7-.3-.9,0-.3.3-.3.7,0,.9l3,3H0v1.3h37.7l-3,3c-.3.3-.3.7,0,.9s.7.3.9,0l4.2-4.2c.3-.3.3-.7,0-.9h0Z',
	}).mount({
		SlideCounterExtension
	});
});

var awardArticlesSplide = document.querySelectorAll('.js-awards-articles-slider');
if (awardArticlesSplide.length) {
	for (var i = 0; i < awardArticlesSplide.length; i++) {
		var splideElement = awardArticlesSplide[i];
		var splideDefaultOptions = {
			type: 'loop',
			perPage: 3,
			perMove: 1,
			arrows: true,
			pagination: false,
			gap: '20px',
			lazyLoad: 'nearby',
			arrowPath: 'M39.8,19.6l-4.2-4.2c-.3-.3-.7-.3-.9,0-.3.3-.3.7,0,.9l3,3H0v1.3h37.7l-3,3c-.3.3-.3.7,0,.9s.7.3.9,0l4.2-4.2c.3-.3.3-.7,0-.9h0Z',
			breakpoints: {
				768: {
					perPage: 1
				},
			},
		}
		var splide = new Splide(splideElement, splideDefaultOptions);
		splide.mount({
			SlideCounterExtension
		});
	}
}

if (document.getElementsByClassName("js-speaker-slider").length) {
	new Splide('.js-speaker-slider', {
		type: 'loop',
		perPage: 3,
		arrows: true,
		pagination: false,
		gap: '20px',
		lazyLoad: 'nearby',
		arrowPath: 'M39.8,19.6l-4.2-4.2c-.3-.3-.7-.3-.9,0-.3.3-.3.7,0,.9l3,3H0v1.3h37.7l-3,3c-.3.3-.3.7,0,.9s.7.3.9,0l4.2-4.2c.3-.3.3-.7,0-.9h0Z',
		breakpoints: {
			768: {
				perPage: 1
			},
		},
	}).mount({
		SlideCounterExtension
	});
}

if (document.getElementsByClassName("js-testimonials-slider").length) {
	new Splide('.js-testimonials-slider', {
		type: 'loop',
		perPage: 1,
		arrows: true,
		pagination: false,
		gap: '20px',
		lazyLoad: 'nearby',
		arrowPath: 'M39.8,19.6l-4.2-4.2c-.3-.3-.7-.3-.9,0-.3.3-.3.7,0,.9l3,3H0v1.3h37.7l-3,3c-.3.3-.3.7,0,.9s.7.3.9,0l4.2-4.2c.3-.3.3-.7,0-.9h0Z',
	}).mount({
		SlideCounterExtension
	});
}
if (document.getElementsByClassName("js-shop-image-slider").length) {
	var shopGalleryMain = new Splide('.js-shop-image-slider', {
		type: 'loop',
		perPage: 1,
		arrows: false,
		pagination: false,
		gap: '20px',
		lazyLoad: 'nearby',
	});
	var shopGalleryThumbs = new Splide('.js-shop-thumb-slider', {
		type: 'loop',
		isNavigation: true,
		perPage: 3,
		focus: 'center',
		arrows: true,
		pagination: false,
		gap: '20px',
		lazyLoad: 'nearby',
		arrowPath: 'M39.8,19.6l-4.2-4.2c-.3-.3-.7-.3-.9,0-.3.3-.3.7,0,.9l3,3H0v1.3h37.7l-3,3c-.3.3-.3.7,0,.9s.7.3.9,0l4.2-4.2c.3-.3.3-.7,0-.9h0Z',
	});
	shopGalleryMain.sync(shopGalleryThumbs);
	shopGalleryMain.mount();
	shopGalleryThumbs.mount();
}


/* ==========================================================================
   Counter Animation
   ========================================================================== */

// Source: https://getbutterfly.com/animated-javascript-counter-up-with-the-intersection-observer-api/

const counterObserver = new IntersectionObserver((entries, observer) => {
	entries.forEach(entry => {
		// If the element is in view, start counter animation
		if (entry.isIntersecting) {
			const target = entry.target;
			const finalValue = Number.parseInt(target.textContent, 10);
			const startValue = finalValue > 10 ? finalValue - 10 : 0;
			const duration = 2.5 * 1000;
			const startTime = performance.now();
			target.textContent = startValue;

			const animateCounter = (currentTime) => {
				const elapsedTime = currentTime - startTime;
				const progress = Math.min(elapsedTime / duration, 1);
				const currentValue = Math.ceil(startValue + (progress * (finalValue - startValue)));
				target.textContent = currentValue;

				if (progress < 1) {
					requestAnimationFrame(animateCounter);
				}
			};

			requestAnimationFrame(animateCounter);
			// Stop observing the element to prevent duplicate animations
			counterObserver.unobserve(target);
		}
	});
});

// Observe each .counterup element
document.querySelectorAll('.js-counter').forEach(element => {
	counterObserver.observe(element);
});

/* ==========================================================================
   Custom Slider Cursor
   ========================================================================== */

const cursorSliders = document.querySelectorAll('.splide-wrapper')
const cursorSlideItems = document.querySelectorAll(".splide__slide");
const cursorCounter = document.querySelector(".slider-cursor .slider-cursor__counter");
let cursorOutput = "";

function updateSliderCursor(event) {
	var thisEl = this.querySelector(".slider-cursor");
	var thisMessage = thisEl.querySelector(".slider-cursor__counter");
	var thisRect = this.getBoundingClientRect();
	thisEl.style.top = (event.clientY - thisRect.top) + "px";
	thisEl.style.left = (event.clientX - thisRect.left) + "px";
	thisMessage.innerHTML = cursorOutput;
	thisMessage.classList.add("is-visible");
}

function updateSliderCursorLeave(event) {
	var thisEl = this.querySelector(".slider-cursor");
	var thisMessage = thisEl.querySelector(".slider-cursor__counter");
	thisMessage.classList.remove("is-visible")
}

cursorSliders.forEach(slider => {
	slider.addEventListener("mousemove", updateSliderCursor, false);
	slider.addEventListener("mouseenter", updateSliderCursor, false);
	slider.addEventListener("mouseleave", updateSliderCursorLeave, false);
});

cursorSlideItems.forEach(slideItem => {
	slideItem.addEventListener("mouseover", function () {
		cursorCounter.innerHTML = slideItem.getAttribute("aria-label");
		cursorOutput = cursorCounter.innerHTML.replace("of", "/");
	})
})

/* ==========================================================================
   A11y Accordion Tabs
   ========================================================================== */

new AccordionTabs(document.querySelector(".js-architect-profile-tabs"), {
	breakpoint: 1024,
	tabsAllowed: true,
	startCollapsed: false
});

new AccordionTabs(document.querySelector(".js-join-tabs"), {
	breakpoint: 1024,
	tabsAllowed: true,
	startCollapsed: false
});

const accordions = document.querySelectorAll(".js-insitu-schedule-accordion");

accordions.forEach(accordion => {
	new AccordionTabs(accordion, {
		tabsAllowed: false,
		startCollapsed: true
	});
});

new AccordionTabs(document.querySelector(".js-insitu-pricing-accordion"), {
	tabsAllowed: false,
	startCollapsed: true
});

/* ==========================================================================
   Fancybox Lightbox
   ========================================================================== */

Fancybox.bind('[data-fancybox]', {
	Html: {
		youtube: {
			controls: 0,
			rel: 0,
			fs: 0
		}
	}
});

/* ==========================================================================
   Read more/less toggle
   ========================================================================== */

const readMoreButton = document.querySelector(".js-read-more");
const readMoreContent = document.querySelector("#read-more-content");

if (readMoreButton) {
	readMoreButton.addEventListener("click", function () {
		readMoreContent.classList.toggle("is-active");
		this.classList.toggle("is-active");
		if (this.innerHTML == "Read More") {
			this.innerHTML = "Read Less";
		} else {
			this.innerHTML = "Read More";
		}
	});
}


/* ==========================================================================
   Join Form Button
   ========================================================================== */
window.addEventListener('DOMContentLoaded', () => {
const joinTodayButton = document.querySelector(".js-trigger-join-tab");

if (joinTodayButton) {
	joinTodayButton.addEventListener("click", function () {
		document.getElementById('apply-now').click();
	});
}
});

/*    Please don't remove sections below, when you override this file from static HTML's app.js /*

/* ========================================================================================
   ======================================================================================== */

window.toggleSearchModal = toggleSearchModal;
window.toggleArchitectLocationPopup = toggleArchitectLocationPopup;
window.toggleArchitectProjectTypePopup = toggleArchitectProjectTypePopup;

const shoppingCartHeader = document.querySelector(".header-shopping-cart");

if (shoppingCartHeader) {
	const counter = shoppingCartHeader.querySelector(".header-shopping-cart__count");

	// read counter from cookie
	const cookieValue = document.cookie.split('; ').find(row => row.startsWith('nzia_scti='));

	if (cookieValue) {
        const count = cookieValue.split('=')[1];
		if (count) {
			counter.style.display = "flex";
			counter.innerHTML = count;
		} else {
			// hide counter if no value
            counter.style.display = "none";
        }
	} else {
		// hide counter if no value
		counter.style.display = "none";
	}

}

/* ==========================================================================
   Video Gallery Year Filter
   ========================================================================== */
window.addEventListener('DOMContentLoaded', function () {
	const select = document.getElementById('year-filter');
	if (!select) return;

	function filterTiles(year) {
		document
			.querySelectorAll('.resource-tile[data-year]')
			.forEach(function (tile) {
				tile.style.display =
					(!year || tile.dataset.year === year) ? '' : 'none';
			});
	}

	filterTiles(select.value);

	select.addEventListener('change', function () {
		filterTiles(this.value);
	});
});
